import React from 'react';
import cx from 'classnames';
import '../../rewards/Progress/index.js';
import { RewardIcon } from '../../rewards/RewardIcon/index.js';
import { RewardIconWrapper } from '../../rewards/RewardIconWrapper/index.js';
import '../../rewards/RewardsProgressBar/index.js';
import '../../rewards/RewardStatus/index.js';
import '../../rewards/VipIcon/index.js';
import '../../rewards/InstantRakeback/index.js';
import '../../rewards/Range/index.js';
import '../../rewards/VipReload/index.js';
import '../../rewards/RewardWallet/index.js';
import '../../rewards/RewardHorizontal/index.js';
import '../../rewards/RewardHorizontalV2/index.js';
import '../../rewards/Reward/index.js';
import '../../rewards/AvailableProgress/index.js';
import '../../rewards/Benefits/index.js';
import '../../rewards/CountDownBanner/index.js';
import '../../rewards/ProgressWidget/index.js';
import '../../rewards/RewardsSliderPreview/index.js';
import '../../rewards/RewardsSlider/index.js';
import '../../rewards/VipLevelLine/index.js';
import '../../rewards/VipLevelAccordion/index.js';
import '../../rewards/VipProgress/index.js';
import '../../rewards/VipRewards/index.js';
import '../../rewards/RewardsList/index.js';
import '../../rewards/RewardTypeIcon/index.js';
import '../../rewards/RewardsDropdown/RDContent/index.js';
import '../../rewards/RewardsDropdown/RDFooter/index.js';
import '../../rewards/RewardsDropdown/RDHeader/index.js';
import '../../rewards/RewardsDropdown/RDList/index.js';
import '../../rewards/RewardsDropdown/RDRow/index.js';
import '../../rewards/RewardsDropdown/RDStatistic/index.js';
import '../../rewards/RewardsDropdown/RDWrapper/index.js';
import styles from './index.module.scss.js';

const NameWithVip = ({
  name,
  vipLevel,
  className,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { ...props, className: cx(styles.box) }, /* @__PURE__ */ React.createElement(RewardIconWrapper, { icon: vipLevel, className: styles.vip }, /* @__PURE__ */ React.createElement(RewardIcon, { icon: vipLevel })), /* @__PURE__ */ React.createElement("div", { className: styles.name }, name));

export { NameWithVip };
//# sourceMappingURL=index.js.map
